export default __webpack_public_path__ + "static/media/tripod-open.0c3e2197.png";